<div class="flex row p-2 justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate">
        Daily Activity Tracker
    </div>
    <div>
        <mat-icon
            mat-dialog-close
            [svgIcon]="'heroicons_solid:x-mark'"
        ></mat-icon>
    </div>
</div>
<hr class="my-0" />

<mat-dialog-content>
    <form [formGroup]="form" class="w-full grid grid-cols-2 gap-2">
        <mat-form-field class="col-span-1">
            <mat-label>Start Date</mat-label>
            <input
                matInput
                [matDatepicker]="startPicker"
                formControlName="startDate"
                [max]="today"
            />
            <mat-datepicker-toggle
                matIconSuffix
                [for]="startPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>
    </form>
    <hr />
    <div
        class="w-full grid grid-cols-1 gap-2"
        *ngFor="
            let detail of form.controls.dailyActivityTrackerDetails.getRawValue();
            let i = index
        "
    >
        <div class="grid grid-cols-4 gap-2">
            <mat-form-field class="col-span-3">
                <mat-label>Activity Date</mat-label>
                <input
                    matInput
                    [matDatepicker]="acitivtyDate"
                    [formControl]="detail.activityDate"
                    [max]="today"
                />
                <mat-datepicker-toggle
                    matIconSuffix
                    [for]="acitivtyDate"
                ></mat-datepicker-toggle>
                <mat-datepicker #acitivtyDate></mat-datepicker>
            </mat-form-field>
            <div>
                <mat-label class="invisible">Action</mat-label>
                <br />
                <button class="btn btn-outline btn-error col-span-1 w-1/2" (click)="deleteDetail(detail, i)">
                    -
                </button>
            </div>
        </div>
        <mat-form-field class="w-full">
            <mat-label>Detail</mat-label>
            <textarea
                matInput
                rows="4"
                [formControl]="detail.dailyActivity"
            ></textarea>
        </mat-form-field>
        <hr />
    </div>
    <div class="flex justify-end">
        <button class="btn btn-primary" (click)="addDetail()">+ Add Activity</button>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="btn btn-outline btn-error mx-1" mat-dialog-close>
        Cancel
    </button>
    <button class="btn btn-primary mx-1" (click)="update()">Save</button>
    <button class="btn btn-outline btn-success mx-1" (click)="completeDialog()" *ngIf="data.payload.activityStatus == 'Open'">Complete</button>
</mat-dialog-actions>
